/// <reference types="vite/client" />
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
	RouteContext,
	Scripts,
} from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { ThemeProvider } from '@frontend/ui/components/theme-provider';
import { setDefaultOptions } from 'date-fns';
import { nb } from 'date-fns/locale';
import css from '@frontend/ui/styles/styles.css?url';
import { create, StoreApi, UseBoundStore } from 'zustand';

export interface ResaniRouterContext extends RouteContext {
	queryClient: QueryClient;
	crumb?: string;
}

export const Route = createRootRouteWithContext<ResaniRouterContext>()({
	head: () => ({
		meta: [
			{
				charSet: 'utf-8',
			},
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1',
			},
			{ title: 'Resani' },
		],
		links: [{ rel: 'stylesheet', href: css }],
	}),
	component: () => (
		<RootDocument>
			<ThemeProvider>
				<Outlet />
			</ThemeProvider>
			{/*
			{import.meta.env.DEV && (
				<>
					<TanStackRouterDevtools position="bottom-right" />
					<ReactQueryDevtools buttonPosition="top-right" />
				</>
			)}
      */}
		</RootDocument>
	),
});

function RootDocument({ children }: { children: React.ReactNode }) {
	setDefaultOptions({ locale: nb });

	return (
		<html lang="en" className="h-screen w-screen">
			<head>
				<HeadContent />
			</head>
			<body className="h-full w-full flex">
				{children}
				<Scripts />
			</body>
		</html>
	);
}
